import React, {useEffect, Fragment} from 'react';
import {connect} from "react-redux";
import {hashHistory} from "react-router";

import {modifyPageLayoutComponents} from "../PageLayout";
import WizardSetupHeader from "./WizardSetupHeader";
import WizardSetupFooter from "./WizardSetupFooter";
import WizardSetupTopButtons from "./WizardSetupTopButtons";
import {getWizardList, setWizardList, setWizardListReceived} from "./wizardActions";
import WizardSetupList from "./WizardSetupList";
// import {getFabricatorSubscriptions, getQtCategories} from "../NewScope/newScopeActions";
import {getFabricatorSubscriptions} from "../NewScope/newScopeActions";
import PS from '../ProjectScope/ProjectScopeActionsNew';
import {setPresetsReceived} from "../VisualizerManagement/VisualizerManagementActions";
import WizardGroups from "./WizardGroups/WizardGroups";

import {usePrevious} from "../../utilities/helperHooks";
import {setBufferWizardItems} from "./wizardFlowActions";

const WizardSetup = (props) => {

  const {getWizardList, getFabricatorSubscriptions, loadFeaturesGroups, setPresetsReceived, routeParams, wizardVisualizer,
    setWizardListReceived, setWizardList, setBufferWizardItems} = props;
  const {wizardId} = routeParams;
  const prevWizardVisualizer = usePrevious(wizardVisualizer);

  useEffect(() => {
    getFabricatorSubscriptions();
    loadFeaturesGroups(false);
    return () => {
      setPresetsReceived(false);
      setWizardListReceived(false);
      setWizardList([]);
      setBufferWizardItems([], [], null);
    }
  }, []);

  useEffect(() => {
    if (wizardVisualizer && wizardVisualizer !== prevWizardVisualizer) {
      setWizardListReceived(false);
      getWizardList(wizardVisualizer);
    } else if (!wizardVisualizer && wizardId) {
      hashHistory.push("/wizard/");
    }
  }, [wizardVisualizer])

  return (
    <div className={"wizard" + (wizardId ? " wizard--groups" : "")}>
      {wizardId ? (
        <WizardGroups wizardId={+wizardId}/>
      ) : (
        <Fragment>
          <WizardSetupTopButtons/>
          <WizardSetupList/>
        </Fragment>
      )}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardVisualizer} = store.wizardState;
  return {
    wizardVisualizer
  };
};

const mapDispatchToProps = {
  getWizardList,
  getFabricatorSubscriptions,
  // getQtCategories,
  setWizardListReceived,
  loadFeaturesGroups: PS.loadFeaturesGroups,
  setPresetsReceived,
  setWizardList,
  setBufferWizardItems,
};

export default modifyPageLayoutComponents({
  pageHeader: WizardSetupHeader,
  content: connect(mapStateToProps, mapDispatchToProps)(WizardSetup),
  pageFooter: WizardSetupFooter,
});
